const urlMenuIdAdditionnally = {
    /**
     * additional legacy path (ex: for overview)
     **/ 

    // massmailing
    '/?_f=massmailing_campaign'    : 'massmailing',
    '/?_f=massmailing_campaignForm': 'massmailing',
    // project
    '/?_f=project_project': 'project',
    // purchases
    '/?_f=purchases_purInvoiceOverview'   : 'purchases',
    '/?_f=purchases_purDeliveryOverview'  : 'purchases',
    '/?_f=purchases_purCreditNoteOverview': 'purchases',
    '/?_f=purchases_purOrderOverview'     : 'purchases',
    '/?_f=purchases_purInvoiceForm'       : 'purchases',
    '/?_f=purchases_purDeliveryForm'      : 'purchases',
    '/?_f=purchases_purCreditNoteForm'    : 'purchases',
    '/?_f=purchases_purOrderForm'         : 'purchases',
    // invoicing
    '/?_f=invoiceOverview'   : 'invoicing',
    '/?_f=estimateOverview'  : 'invoicing',
    '/?_f=creditnoteOverview': 'invoicing',
    // catalogue
    '/?_f=catalogueitem': 'catalogue',
    // proposal
    '/?_f=proposal_builder' : 'proposal',
    '/?_f=proposal_proposal': 'proposal',

    /**
     * additional vue path (beta views)
     **/

    // catalogue
    '/catalogue/items'   : 'catalogue',
    '/catalogue/services': 'catalogue',
    // project
    '/project/projects': 'project',
    '/project/entries' : 'project',
    // reports
    '/invoicing/reporting/salesbythird': 'reports',
    // purchases
    '/purchase/purInvoice': 'purchases',
};

export { urlMenuIdAdditionnally };